var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"doc_wrapper"},[_c('quic-filter',{attrs:{"list":_vm.list},on:{"selected":_vm.selected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }